/**
 * A raw user agent is unreadable noise; the admin needs "iPhone · Safari", not a token soup.
 * Best-effort by design — an unknown agent falls back to "Unbekanntes Gerät".
 */
export function formatDeviceLabel(userAgent: string | null): string {
  if (!userAgent) return "Unbekanntes Gerät";

  const device = /iPhone/i.test(userAgent)
    ? "iPhone"
    : /iPad/i.test(userAgent)
      ? "iPad"
      : /Android/i.test(userAgent)
        ? "Android"
        : /Windows/i.test(userAgent)
          ? "Windows"
          : /Macintosh|Mac OS/i.test(userAgent)
            ? "Mac"
            : /Linux/i.test(userAgent)
              ? "Linux"
              : null;

  // Order matters: Chrome and Edge both carry "Safari", Edge also carries "Chrome".
  const browser = /Edg\//i.test(userAgent)
    ? "Edge"
    : /Firefox\//i.test(userAgent)
      ? "Firefox"
      : /Chrome\/|CriOS\//i.test(userAgent)
        ? "Chrome"
        : /Safari\//i.test(userAgent)
          ? "Safari"
          : null;

  if (device && browser) return `${device} · ${browser}`;
  return device ?? browser ?? "Unbekanntes Gerät";
}
